import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    padding: 20,
    backgroundColor: '#fff',
    flex: 1,
  },
  imageStyle: {
    width: 110,
    height: 110,
    alignSelf: 'center',
    marginVertical: 12,
  },
  overlayIcon: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: [{translateX: 45}],
    width: 30,
    height: 30,
    tintColor: 'red',
  },
  description: {
    /* maxWidth: 150, */
    fontSize: 15,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 15,
    tintColor: 'red',
    paddingTop: 20,
    color: '#000',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginTop: 10,
    color: '#000',
  },
  price: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#000',
    marginVertical: 5,
  },
  badge: {
    backgroundColor: '#FF7F50',
    paddingVertical: 5,
    paddingHorizontal: 10,
    borderRadius: 5,
    alignSelf: 'flex-start',
    marginBottom: 20,
  },
  badgeText: {
    color: '#fff',
    fontWeight: 'bold',
  },
  label: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#000',
  },
  quantityContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  button: {
    fontSize: 24,
    color: '#000',
    paddingHorizontal: 15,
  },
  arrow: {},
  input: {
    borderWidth: 1,
    borderColor: '#CCC',
    borderRadius: 10,
    textAlign: 'center',
    flex: 1,
    fontSize: 18,
    paddingVertical: 5,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: 'black',
  },
          priceRangesGrid: {
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 4,
          justifyContent: 'space-between',
          marginTop: 12,
        },
        priceRangeCard: {
          width: '48%',
          padding: 7,
          borderRadius: 6,
          backgroundColor: '#fff',
          borderWidth: 1.5,
          borderColor: '#ddd',
          alignItems: 'center',
          justifyContent: 'center',
        },
        selectedCard: {
          borderColor: '#21ce2f',
          backgroundColor: '#ecf9f1',
        },
        disabledCard: {
          borderColor: '#ddd',
          backgroundColor: '#f5f5f5',
        },
        priceRangeText: {
          fontSize: 12,
          color: '#333',
          textAlign: 'center',
          marginBottom: 2,
        },
        priceRangeValue: {
          fontSize: 14,
          fontWeight: 'bold',
          color: '#ec1f24',
        },
        disabledText: {
          color: '#aaa',
        },
        
  priceRange: {
    marginTop: 1.5,
    fontSize: 12,
    color: '#333',
  },
  helperText: {
    fontSize: 12,
    color: '#666',
    marginBottom: 20,
  },
  hasItem: {
    fontSize: 10,
    fontFamily: 'TCCC-UnityHeadline Regular',
    lineHeight: 14,
    color: 'gray',
  },
  quickAddContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '90%',
    maxWidth: 300,
    marginHorizontal: 'auto',
  },
  quickAddButton: {
    backgroundColor: '#D50000',
    color: '#fff',
    fontSize: 12,
    paddingVertical: 5,
    paddingHorizontal: 20,
    borderRadius: 10,
  },
  infoContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 10,
  },
  title2: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    color: '#000',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 5,
  },
  value: {
    fontSize: 14,
    color: '#000',
    fontWeight: 'bold',
  },
  totalLabel: {
    fontWeight: 'bold',
  },
  totalValue: {
    fontSize: 16,
  },
  confirmButton: {
    backgroundColor: '#D50000',
    color: '#fff',
    fontSize: 14,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderRadius: 10,
    textAlign: 'center',
  },
});
